import { DataFlag } from './dataFlag.shared.model.js';
export const dailyEntrySaveInputLimit = 750;
export var Mens = /*#__PURE__*/function (Mens) {
  Mens[Mens["MENSTRUATION"] = 1] = "MENSTRUATION";
  Mens[Mens["SPOTTING"] = 2] = "SPOTTING";
  Mens[Mens["WITHDRAWAL"] = 3] = "WITHDRAWAL";
  Mens[Mens["MISCARRIAGE_BLEEDING"] = 4] = "MISCARRIAGE_BLEEDING";
  Mens[Mens["POSTPARTUM_BLEEDING"] = 5] = "POSTPARTUM_BLEEDING";
  return Mens;
}(Mens || {});
export var HadSex = /*#__PURE__*/function (HadSex) {
  HadSex[HadSex["YES"] = 1] = "YES";
  HadSex[HadSex["YES_PROTECTED"] = 2] = "YES_PROTECTED";
  HadSex[HadSex["NO"] = 3] = "NO";
  return HadSex;
}(HadSex || {});
export var TestResult = /*#__PURE__*/function (TestResult) {
  TestResult[TestResult["YES"] = 1] = "YES";
  TestResult[TestResult["NO"] = 2] = "NO";
  return TestResult;
}(TestResult || {});
export const DEVIATION_REASON_FLAGS_USER = new Set([DataFlag.DEVIATION_REASON_OTHER, DataFlag.DEVIATION_REASON_SLEEP, DataFlag.DEVIATION_REASON_ALCOHOL, DataFlag.DEVIATION_REASON_SICK]);
export const DEVIATION_REASON_FLAGS_OURA_ALGO = new Set([DataFlag.OURA_IRREGULAR_SLEEP, DataFlag.OURA_INCOMPLETE_DATA]);
export const DEVIATION_REASON_FLAGS = new Set([...DEVIATION_REASON_FLAGS_USER, ...DEVIATION_REASON_FLAGS_OURA_ALGO, DataFlag.DEVIATION_REASON_ALGO]);
export var DataQuantity = /*#__PURE__*/function (DataQuantity) {
  DataQuantity[DataQuantity["NONE"] = 1] = "NONE";
  DataQuantity[DataQuantity["LIGHT"] = 2] = "LIGHT";
  DataQuantity[DataQuantity["MEDIUM"] = 3] = "MEDIUM";
  DataQuantity[DataQuantity["HEAVY"] = 4] = "HEAVY";
  return DataQuantity;
}(DataQuantity || {});
/**
 * Explicitly defined, cause NONE value is not permitted
 */
export const MENS_QUANTITY_VALUES = [DataQuantity.LIGHT, DataQuantity.MEDIUM, DataQuantity.HEAVY];
export var CervicalMucusConsistency = /*#__PURE__*/function (CervicalMucusConsistency) {
  CervicalMucusConsistency[CervicalMucusConsistency["STICKY"] = 1] = "STICKY";
  CervicalMucusConsistency[CervicalMucusConsistency["CREAMY"] = 2] = "CREAMY";
  CervicalMucusConsistency[CervicalMucusConsistency["EGGWHITE"] = 3] = "EGGWHITE";
  CervicalMucusConsistency[CervicalMucusConsistency["WATERY"] = 4] = "WATERY";
  return CervicalMucusConsistency;
}(CervicalMucusConsistency || {});
export var SexType = /*#__PURE__*/function (SexType) {
  SexType[SexType["CONDOM"] = 1] = "CONDOM";
  SexType[SexType["WITHDRAWAL"] = 2] = "WITHDRAWAL";
  SexType[SexType["NO_WITHDRAWAL"] = 3] = "NO_WITHDRAWAL";
  SexType[SexType["OTHER"] = 4] = "OTHER";
  return SexType;
}(SexType || {});
export const SEX_TYPE_PROTECTED_VALUES = new Set([SexType.OTHER, SexType.CONDOM]);
export const SEX_TYPE_UNPROTECTED_VALUES = new Set([SexType.WITHDRAWAL, SexType.NO_WITHDRAWAL]);
export var Libido = /*#__PURE__*/function (Libido) {
  Libido[Libido["LOW"] = 1] = "LOW";
  Libido[Libido["MEDIUM"] = 2] = "MEDIUM";
  Libido[Libido["HIGH"] = 3] = "HIGH";
  return Libido;
}(Libido || {});
export var DataIntensity = /*#__PURE__*/function (DataIntensity) {
  DataIntensity[DataIntensity["NONE"] = -1] = "NONE";
  DataIntensity[DataIntensity["LOW"] = 1] = "LOW";
  DataIntensity[DataIntensity["MEDIUM"] = 2] = "MEDIUM";
  DataIntensity[DataIntensity["HIGH"] = 3] = "HIGH";
  return DataIntensity;
}(DataIntensity || {});
export var Sleep = /*#__PURE__*/function (Sleep) {
  Sleep[Sleep["POOR"] = 1] = "POOR";
  Sleep[Sleep["OKAY"] = 2] = "OKAY";
  Sleep[Sleep["RESTFUL"] = 3] = "RESTFUL";
  return Sleep;
}(Sleep || {});
export var BabyFeedingType = /*#__PURE__*/function (BabyFeedingType) {
  BabyFeedingType[BabyFeedingType["BREASTFEEDING"] = 1] = "BREASTFEEDING";
  BabyFeedingType[BabyFeedingType["BOTTLE_FEEDING"] = 2] = "BOTTLE_FEEDING";
  BabyFeedingType[BabyFeedingType["PUMPING"] = 3] = "PUMPING";
  return BabyFeedingType;
}(BabyFeedingType || {});